<template>
  <section
    class="infoColumn"
    :style="{ backgroundColor: box.boxColor, color: box.boxText }"
  >
    <div class="card-header">
      <span
        class="card-title-custom"
        v-if="customFonts.customFonts"
        :style="{
          'font-family': customFonts.customFontCss,
          'font-size': customFonts.customFontSize,
        }"
        >{{ isSecLangActive ? box.headlineSec : box.headline }}</span
      >
      <h4 class="card-title" v-else>
        {{ isSecLangActive ? box.headlineSec : box.headline }}
      </h4>
      <ul class="inAndOut">
        <li v-if="box.checkins[0] !== ''">
          <h5>CHECK-IN</h5>
          <span>{{ isSecLangActive ? box.checkins[1] : box.checkins[0] }}</span>
        </li>
        <li v-if="box.checkouts[0] !== ''">
          <h5>CHECK-OUT</h5>
          <span>{{
            isSecLangActive ? box.checkouts[1] : box.checkouts[0]
          }}</span>
        </li>
      </ul>
    </div>
    <div
      class="card-content"
      :class="{
        noCheckInOrCheckOut: box.checkins[0] === '' && box.checkouts[0] === '',
        checkInOrCheckoutOverlap: applyOverlapStyles(box),
      }"
    >
      <div v-for="ability in box.roomAbilities" :key="ability.title">
        <ul class="abilityList">
          <li>
            <v-icon v-if="ability.allowed" name="check" scale="1"></v-icon>
            <v-icon v-if="!ability.allowed" name="times" scale="1"></v-icon>
          </li>
          <li>{{ isSecLangActive ? ability.titleSec : ability.title }}</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import "../../vue-awesome-icons";

export default {
  props: {
    box: Object,
    cookieExists: [String],
    secondLang: Boolean,
    activeLanguage: String,
    customFonts: Object,
  },
  computed: {
    isSecLangActive() {
      return this.secondLang && this.cookieExists;
    },
    computedBoxes() {
      return this.guestBoxes;
    },
  },
  methods: {
    applyOverlapStyles(box) {
      if (box.checkins[1] && box.checkouts[1]) {
        return (
          box.checkins[1].length + box.checkouts[1].length > 25 ||
          box.checkins[0].length + box.checkouts[0].length > 25
        );
      } else {
        return box.checkins[0].length + box.checkouts[0].length > 25;
      }
    },
  },
};
</script>
<style scoped>
.infoColumn {
  background-position: center;
  text-align: center;
  /* float: left; */
  /* width: 320px; */
  width: 100%;
  padding: 10px;
  padding-top: 25px;
  /* margin: 10px; */
  height: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

.card-title-custom {
  font-size: 2.5em;
  line-height: 1;
}
.card-title {
  margin: 8px 0 16px 0;
  font-size: 1.25rem;
  font-weight: 500; /* Medium */
  overflow: hidden;
}
.card-header h5 {
  margin: 0;
}
div.checkInOrCheckoutOverlap {
  height: 275px;
}

div.noCheckInOrCheckOut {
  height: 430px;
}

.abilityList {
  list-style-type: none;
  margin: 0px;
  padding: 5px 5px 5px 20px;
  text-align: left;
  display: flex;
  align-items: center;
}
.abilityList li {
  display: flex;
  margin-right: 15px;
}

div.card-content {
  margin-top: 10px;
  height: 350px;
  overflow: hidden;
}
.inAndOut {
  list-style-type: none;
  margin: 0px;
  padding: 5px 5px 5px 20px;
  text-align: left;
}
.inAndOut li {
  display: inline-block;
  margin: 0px 30px 0px 0px;
}
.inAndOut h5 {
  margin-bottom: 5px;
  font-weight: bold;
}
</style>
